export const formatPrice = (price, currency = { currencyName: 'VND' }) => {
  try {
    if (!price) return '0';

    if (currency.currencyName === 'USD') {
      // Convert VND to USD (assuming 1 USD = 25,000 VND)
      const usdPrice = price / 25000;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(usdPrice);
    }

    // Default to VND
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(price);

  } catch (error) {
    console.error('Error formatting price:', error);
    // Fallback formatting
    if (currency.currencyName === 'USD') {
      return `$${(price / 25000).toFixed(2)}`;
    }
    return `${price.toLocaleString('vi-VN')}₫`;
  }
};